import React from 'react';
import { Link } from 'react-router-dom';

export default function AuthFooter() {
  return (
    <footer className="auth-footer">
      <span>© 2026 Cybernate AI</span>
      <div className="auth-footer__links">
        <Link to="/legal">Privacy</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/legal">Cookies</Link>
        <a href="mailto:hello@cybernate.ai">Contact</a>
      </div>
    </footer>
  );
}
